module.exports = __webpack_public_path__ + "img/adress_details_white.92e4b1fa.svg";